<ng-container *transloco="let t; read: 'create-callback-request-button'">
  <p-toast position="bottom-center"></p-toast>
  <p-button
    [disabled]="!hasWidgets || widgetsLoading"
    label="{{ t('buttonLabel') }}"
    [loading]="widgetsLoading"
    (onClick)="buttonClick()"
  ></p-button>
</ng-container>
